import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-policy',
  templateUrl: './research-policy.component.html',
  styleUrls: ['./research-policy.component.scss']
})
export class ResearchPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
